import { render, staticRenderFns } from "./ListOfUserDeleted.vue?vue&type=template&id=028b0b2a"
import script from "./ListOfUserDeleted.vue?vue&type=script&lang=js"
export * from "./ListOfUserDeleted.vue?vue&type=script&lang=js"
import style0 from "./ListOfUserDeleted.vue?vue&type=style&index=0&id=028b0b2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports